import { Box, Button, Typography } from "@material-ui/core";
import React from "react";

import { useStyles } from "../theme/styles/components/headerStyles";
import cross from "../assets/cross.svg";
import { useHistory } from "react-router-dom";

export default function SimpleModal({ handleClose }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box onClick={handleClose} alignSelf="flex-end">
          <span className={classes.cross}>
            <img src={cross} alt="cancel" />
          </span>
        </Box>

        <Typography variant="h5">
          <Box p={5} display="flex" flexDirection="column" alignItems="center">
            <Button
              onClick={() => {
                history.push("/kol-registration");
              }}
              className={classes.walletButton}
            >
              Join as KOL
            </Button>
            <Box m={2} fontWeight="fontWeightBold">
              or
            </Box>
            <Button
              onClick={() => {
                history.push("/registration");
              }}
              className={classes.walletButton}
            >
              List your project
            </Button>
          </Box>
        </Typography>
      </Box>
    </div>
  );
}
